import { createBrowserRouter } from 'react-router-dom';
import App from './App';

// Pages
import Index from './pages/Index';
import ONas from './pages/O-nas';
import Kontakt from './pages/Kontakt';
import Oprema from './pages/Oprema';
import Intervencije from './pages/Intervencije';
import Donacija from './pages/Donacija';
import NotFound from './pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <NotFound />,
    children: [
      {
        path: '',
        element: <Index />,
      },
      {
        path: 'o-nas',
        element: <ONas />,
      },
      {
        path: 'kontakt',
        element: <Kontakt />,
      },
      {
        path: 'oprema',
        element: <Oprema />,
      },
      {
        path: 'intervencije',
        element: <Intervencije />,
      },
      {
        path: 'donacija',
        element: <Donacija />,
      },
    ],
  },
]);

export default router;